<!-- 企业级-平台运营-企业缴纳情况-平台缴费 -->
<template>
  <div class="mainArea CPlatFormPay">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="tit">请确认缴费信息</div>
        <div class="cont clearfix">
          <el-form :model="platform" label-width="80px">
            <el-form-item label="续费金额:">{{platform.money}}元</el-form-item>
            <el-form-item label="服务期限:">{{platform.starTime}}~{{platform.endTime}}</el-form-item>
            <el-form-item label="缴费类型:">{{platform.platType}}</el-form-item>
            <el-form-item label="收款名:">{{platform.name}}</el-form-item>
            <el-form-item label="账号:">{{platform.account}}</el-form-item>
          </el-form>
          <div class="item col9">点确认后将跳转到缴费页面</div>
          <div class="item"><el-checkbox v-model="isInvoice">开具发票</el-checkbox></div>
          <div class="item mt30">
            <el-button type="primary" @click="getPlatPay">确认</el-button>
            <el-button @click="backUp">取消</el-button>
          </div>
        </div>
      </div>
      <el-dialog title="支付" :visible.sync="payDio" width="400px" class="payDio" :close-on-click-modal="false" @close="closeEnd">
        <div class="cont_Dio">
          <div class="num">{{platform.money}}元</div>
          <div class="ewm"><img :src="ewm" alt="支付二维码"></div>
          <div class="tips">请使用微信扫描<br>二维码以完成支付</div>
          <div :class="['tips2',payStatus=='1'?'succTips':'']">{{tips}}</div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { platformApi } from "../../../../static/js/api.js"
  let setTime;
  export default {
    name: 'CPlatFormPay',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        platform:{
          money:0,
          starTime:'',
          endTime:'',
          platType:'平台使用费',
          name:'',
          account:'',
        },
        isInvoice:false,//是否开具发票

        payDio:false,//支付弹窗
        ewm:'',
        order_id:'',
        tips:'请尽快支付，10分钟后二维码失效！',
        payStatus:'0',
      }
    },
    mounted(){
    },
    created: async function () {
      const platInfo = JSON.parse(sessionStorage.getItem('platInfo'))
      if(platInfo){
        this.platform.money = platInfo.fee
        this.platform.starTime = platInfo.start_date
        this.platform.endTime = platInfo.end_date
        this.platform.name = platInfo.company_account_name
        this.platform.account = platInfo.company_account
      }
    },
    methods: {
      closeEnd(){
        clearInterval(this.setTime)
      },
      //监听缴费状态
      async checkPayStatus(){
        let that = this;
        const dataObj = {
          'order_id': that.order_id,
        }
        const res = await platformApi.checkPayStatus(dataObj)
        if(res.meta.code == 200){
          if(res.data.status == '1'){
            that.payStatus=res.data.status
            that.tips="支付成功"
            clearInterval(that.setTime)
            setTimeout(function(){
              that.backUp()
            },3000)
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //缴费
      async getPlatPay(){
        let that = this;
        if(that.platform.money == ''||that.platform.money == 0||that.platform.endTime==''){
          return false
        }else{
          const dataObj = {
            'type': '1',
            'number': that.platform.money,
            'bill_flag': that.isInvoice==false? 0 : 1,
          }
          const res = await platformApi.getPlatPay(dataObj)
          if(res.meta.code == 200){
            that.ewm = res.data.code_url
            that.order_id = res.data.order_id
            that.payDio = true
            that.setTime = setInterval(function(){
              that.checkPayStatus()
            },2000)
          }else{
            showToast(res.meta.message)
          }
        }
      },
      //返回上一级
      backUp(){
        this.$router.go(-1);
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto; 
// }
.CPlatFormPay{
  .payDio{
    .el-dialog__body{ padding: 10px 20px 20px;}
    .cont_Dio{
      text-align: center;
      .num{ 
        font-size: 14px;
        color:#333;
      }
      .ewm{
        width: 200px;
        height: 200px;
        margin: 10px auto;
        border: 1px solid #ddd;
        img{ width: 100%;}
      }
      .tips{
        background: #445f85;
        color: #fff;
        padding: 15px 15px 15px 74px;
        position: relative;
        font-size:14px; 
        display: inline-block;
        text-align: left;
        &::before{
          content: "";
          width: 44px;
          height: 44px;
          position: absolute;
          left: 15px;
          top: 50%;
          margin-top: -22px;
          background: url('../../../../static/images/ewm.png') no-repeat;
          background-size: cover;
        }
      }
      .tips2{
        margin-top: 10px;
        color: #999;
        &.succTips{
          color: #67C23A
        }
      }
    }
  }
  .tit{
    font-size:18px;
  }
  .cont{
    margin: 20px 40px;
    font-size: 14px;
    .item{
      margin-bottom: 10px;
      &.col9{ color: #999;}
      &.mt30{ margin-top: 30px;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CPlatformOperate/CPlatFormPay.vue